import * as actionTypes from 'constants/ActionTypes';

export function postRequestVessel(vesselRequest) {
    return {
        type: actionTypes.POST_VESSEL_REQUEST.REQUEST,
        vesselRequest,
    };
}

export function postRequestVesselResponse(response) {
    if (response.status) {
        return {
            type: actionTypes.POST_VESSEL_REQUEST.SUCCESS,
            vesselRequest: response.vesselRequest,
            message: response.message,
        };
    }

    return {
        type: actionTypes.POST_VESSEL_REQUEST.FAILURE,
        vesselRequest: response.vesselRequest,
        error: response.error,
    };
}

export function getRequestsVessel(filter) {
    return {
        type: actionTypes.GET_VESSEL_REQUESTS.REQUEST,
        filter,
    };
}

export function updateRequestVessel(vesselRequestId, userId) {
    return {
        type: actionTypes.UPDATE_VESSEL_REQUEST.REQUEST,
        vesselRequestId,
        userId,
    };
}

export function deleteRequestVessel(vesselId, requestId) {
    return {
        type: actionTypes.DELETE_VESSEL_REQUEST.REQUEST,
        vesselId,
        requestId,
    };
}



// WEBPACK FOOTER //
// ./app/actions/vessels/request.js